export const host = 'https://kalaputriartbackend.herokuapp.com';